import React from 'react'
import SpinnerUI from '../output/SpinnerUI'
import ButtonUI from './ButtonUI'
import './Button.css'

const ButtonWithSpinnerUI = ({label, className, onClick, busy, alignLeft, dataId, disabled, transparent, type}) =>
  <span className={`g_flex_v ${className ? className : ''} ${alignLeft ? '' : 'g_text_right'}`}>
    <span className={`g_flex_h g_m_top_25 ${alignLeft ? 'g_flex_left' : 'g_flex_right'}`}>
      {
        !alignLeft &&
        <SpinnerUI className='g_m_right_50' reserveSpace={true} show={busy} />
      }
      <ButtonUI label={label} onClick={onClick} dataId={dataId} disabled={disabled} transparent={transparent} type={type} />
      {
        alignLeft &&
        <SpinnerUI className='g_m_left_50' reserveSpace={true} show={busy} />
      }
    </span>
  </span>

export default ButtonWithSpinnerUI
